import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { fetchWinner, getAwards } from 'entries/ducks';
import { getProjectIdFromUrl } from 'project/utils';
import { getProject } from 'project/ducks/project';
import WinnerBanner from 'entries/components/winner_banner';

const mapStateToProps = (state, { params }) => ({
  project: getProject(state),
  awards: getAwards(state),
  winner: state.entries.winner,
  projectId: getProjectIdFromUrl(params),
});

export default withRouter(connect(mapStateToProps, { fetchWinner })(WinnerBanner));



// WEBPACK FOOTER //
// ./entries/containers/winner_banner.js